import {
  CLEAR_DATA,
  UPDATE_DATA
} from '../action_types';
import { deepmerge } from 'utilities/merge';
export const data = function(state = {}, action) {
  let newData;
  switch ( action.type ) {
    case UPDATE_DATA:
      // let timestamp = new Date().getTime();
      // console.log('UPDATE_DATA started_at: ', timestamp)
      App.setCurrentPayload({data: action.payload})
      let data = deepmerge(state, action.payload, true);
      // console.log('UPDATE_DATA done_at: ', timestamp - new Date().getTime());
      return data
    case CLEAR_DATA:
      newData = { }
      // notify と response_then　messages だけは残す
      let notify = state['notify'];
      if(notify) {
        newData['notify'] = notify;
      }
      let response_then = state['response_then']
      if(response_then) {
        newData['response_then'] = response_then;
      }
      let messages = state['messages']
      if(messages) {
        newData['messages'] = messages;
      }
      return newData;
    default:
      return state;
  }
};
